import { Component } from '@angular/core';
import { QRCodeService } from 'src/app/services/qrcode/qrcode.service';

@Component({
    selector: 'app-create-url-token',
    templateUrl: './create-url-token.component.html',
})
export class CreateUrlTokenComponent {
    // champs note
    noteId = 0;
    noteCode = '';
    noteTableNumber = 0;
    noteDenomination = '';

    // champs qrcode
    qrUserId = 0;
    qrCode = '';
    qrTableId = 0;

    generatedUrl: string | null = null;
    isLoading = false;
    error: string | null = null;

    constructor(private qrCodeService: QRCodeService) { }

    generateNoteUrl() {
        this.reset();
        this.isLoading = true;
        this.qrCodeService
            .generateNoteUrl(this.noteId, this.noteCode, this.noteTableNumber, this.noteDenomination)
            .subscribe({
                next: (res) => {
                    this.generatedUrl = res.url;
                    this.isLoading = false;
                },
                error: () => {
                    this.error = 'Erreur lors de la génération de l’URL note.';
                    this.isLoading = false;
                }
            });
    }

    generateQRCodeUrl() {
        this.reset();
        this.isLoading = true;
        this.qrCodeService
            .generateQRCodeUrl(this.qrUserId, this.qrCode, this.qrTableId)
            .subscribe({
                next: (res) => {
                    this.generatedUrl = res.url;
                    this.isLoading = false;
                },
                error: () => {
                    this.error = 'Erreur lors de la génération de l’URL QR code.';
                    this.isLoading = false;
                }
            });
    }

    private reset() {
        this.generatedUrl = null;
        this.error = null;
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text).then(() => {
            // console.log('URL copiée dans le presse-papiers');
        }).catch(err => {
            console.error('Erreur lors de la copie :', err);
        });
    }

}
